import { Text } from "@mantine/core"
import { useTranslation } from "react-i18next"
import { peopleURL } from "@/utils"
import { RoleFilter } from "../../controls"
import { icons } from "../icons"
import { TagBox } from "./TagBox"

export function RoleTag({ role }: { role: string }) {
  const { t } = useTranslation()
  const filterValue = role == "owner" ? "admin" : role
  return (
    <TagBox
      href={`${peopleURL}?${RoleFilter.filterName}=${filterValue}`}
      tooltip={t("Role")}
      leftSection={<icons.User size={16} />}
    >
      <Text span tt="capitalize">
        {t(filterValue)}
      </Text>
    </TagBox>
  )
}
